import React from 'react';

import styled from 'styled-components';

import InnerHtml from 'components/InnerHtml/InnerHtml';

import { TabTableColumnI } from 'interfaces/content-stack/modular-blocks/tabTable';
import { ContentAlignmentType } from 'interfaces/styles';

const TableBody = styled.div`
  .TableRow:first-child {
    border-top: 1px solid ${(props) => props.theme.colors.cloudGray};
  }
`;

const TableRow = styled.div<{ $columns: number }>`
  grid-template-columns: repeat(${(props) => props.$columns}, 1fr);
  grid-auto-columns: 1fr;
  display: grid;
  height: 3.0625rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.cloudGray};

  .TableData:last-child {
    border: none;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.xs}) {
    min-width: calc(${(props) => props.$columns} * 6rem);
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
    height: 3rem;
  }
`;

const TableData = styled.div<{
  $mobileStyle: string;
  $alignment: ContentAlignmentType;
  $disableBorder: boolean;
}>`
  ${(props) => `
  font-family: ${props.theme.fonts.default};
  font-weight: 600;
  vertical-align: top;
  text-align: ${props.$alignment ? props.$alignment : 'right'};
  align-items: center;
  justify-content: ${props.$alignment ? props.$alignment : 'right'};
  padding: ${props.$alignment === 'left' ? '0.75rem 1rem 0.75rem 0' : '.75rem 1rem'};
  display: flex;
  
  @media screen and (max-width: ${props.theme.breakpoints.xs}) {
    padding-left: .75rem;
    padding-right: .75rem;
  }
  
  @media screen and (max-width: ${props.theme.breakpoints.md}) {
    font-size: .8125rem;
    ${props.$alignment !== 'left' && 'padding: 0.75rem 0.5rem'};
  }

  ${
    props.$mobileStyle === 'Standard Table'
      ? `
      font-size: 0.875rem;

      @media (min-width: ${props.theme.breakpoints.md}) {
        font-size: 1.125rem;
      }

      && {
        p {
          font-size: 0.875rem;
          margin-bottom: 0;

          @media (min-width: ${props.theme.breakpoints.md}) {
            font-size: 1.125rem;
          }
        }
      }
    `
      : props.$mobileStyle === 'Comparison Row' &&
        `
      font-size: 1rem;

      && {
        p {
          font-size: 1rem;
          margin-bottom: 0;
        }
      }
    `
  }
`}
`;

interface RowDataI {
  content: string;
}

interface TabTableBodyProps {
  columns: TabTableColumnI[];
  mobileStyle: string;
  rows: RowDataI[][];
}

function TabTableBody({ columns, mobileStyle, rows }: TabTableBodyProps) {
  return (
    <TableBody>
      {rows.map((row, index) => {
        return (
          <TableRow key={index} $columns={columns.length} className='TableRow'>
            {row.map((item: RowDataI, index) => (
              <TableData
                className='TableData'
                key={index}
                $mobileStyle={mobileStyle}
                $disableBorder={columns[index].disableBorder}
                $alignment={columns[index].cellAlignment}
              >
                <div>
                  <InnerHtml richText={item.content} />
                </div>
              </TableData>
            ))}
          </TableRow>
        );
      })}
    </TableBody>
  );
}

export default React.memo(TabTableBody);
